import { Chip, Icon } from "@mui/material";

/**
 * The small glyph-and-label pill used on posters and cards. Callers pass `sx`
 * for placement and background, and `testId` to tag it.
 *
 * @param {{ label: string, icon: string, sx?: object, testId?: string }} props
 */
const PillBadge = ({ label, icon, sx, testId }) => (
  <Chip
    size="small"
    label={label}
    data-testid={testId}
    icon={
      <Icon baseClassName="material-symbols-outlined" sx={{ fontSize: "0.85rem !important" }}>
        {icon}
      </Icon>
    }
    sx={{
      height: "20px",
      fontSize: "0.65rem",
      fontWeight: 800,
      color: "#111",
      "& .MuiChip-icon": { color: "#111", ml: "4px", mr: "-2px" },
      ...sx,
    }}
  />
);

export default PillBadge;
